// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompressedNftMetadataCollection
 */
export interface CompressedNftMetadataCollection {
    /**
     * 
     * @type {boolean}
     * @memberof CompressedNftMetadataCollection
     */
    verified: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftMetadataCollection
     */
    key: string;
}

/**
 * Check if a given object implements the CompressedNftMetadataCollection interface.
 */
export function instanceOfCompressedNftMetadataCollection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "verified" in value;
    isInstance = isInstance && "key" in value;

    return isInstance;
}

export function CompressedNftMetadataCollectionFromJSON(json: any): CompressedNftMetadataCollection {
    return CompressedNftMetadataCollectionFromJSONTyped(json, false);
}

export function CompressedNftMetadataCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompressedNftMetadataCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'verified': json['verified'],
        'key': json['key'],
    };
}

export function CompressedNftMetadataCollectionToJSON(value?: CompressedNftMetadataCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'verified': value.verified,
        'key': value.key,
    };
}

